export { TabbedSetWidgetRenderer } from './TabbedSetWidgetRenderer'
